// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#stawag-comparison-staging-gjuce .gc-panels ul{padding-left:0}#stawag-comparison-staging-gjuce .gc-panel-header .v-icon__component{width:12px;height:12px}", ""]);
// Exports
module.exports = exports;
